import { render, staticRenderFns } from "./ConstructorForm.vue?vue&type=template&id=2594759e&scoped=true"
import script from "./ConstructorForm.vue?vue&type=script&lang=ts"
export * from "./ConstructorForm.vue?vue&type=script&lang=ts"
import style0 from "./ConstructorForm.vue?vue&type=style&index=0&id=2594759e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2594759e",
  null
  
)

export default component.exports